var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          showAdd: _vm.showAdd,
          dense: _vm.dense,
          multiple: _vm.multiple,
          selectAll: _vm.selectAll,
          "auto-complete": _vm.autoComplete,
          "item-text": _vm.itemText,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
        },
      }),
      _c("sys-register-place", {
        attrs: { "campus-id": _vm.campusId, model: {}, show: _vm.showForm },
        on: {
          onCompleted: _vm.newItem,
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }